<div class="select-filter" [matMenuTriggerFor]="menu">
  <div class="filter-header">
    {{selectLabel}}{{ label }}
    <span matSuffix class="material-icons arrow-icons">expand_more</span>
  </div>
</div>
<mat-menu #menu="matMenu" xPosition="before">
  <button mat-menu-item *ngFor="let item of data" (click)="change(item)">
    {{ item.label }}
  </button>
</mat-menu>
